module.exports = __webpack_public_path__ + "media/images/facebook-9c74de0da95c133701ef3909778710e1.svg";